import { Badge } from '@/components/ui/badge';
import { CookingPot, Flower2, Waves as Sea } from 'lucide-react';

import { FaWifi } from 'react-icons/fa';
import { TbPool, TbPyramid } from 'react-icons/tb';
import { MdBalcony } from 'react-icons/md';
import { TbAirConditioning } from 'react-icons/tb';
import { FaSwimmingPool } from 'react-icons/fa';
import { FaUmbrellaBeach } from 'react-icons/fa6';
import { MdOutlineOutdoorGrill } from 'react-icons/md';
import { CgGym } from 'react-icons/cg';
import { LuDog } from 'react-icons/lu';
import { BiChair, BiWater } from 'react-icons/bi';
import { BiCameraMovie } from 'react-icons/bi';
import { MdOutlineBathtub } from 'react-icons/md';
import { PiWashingMachine } from 'react-icons/pi';
import { FaSquareParking } from 'react-icons/fa6';
import { FaSmoking } from 'react-icons/fa';
import { TbFridge } from 'react-icons/tb';
import { FaTv } from 'react-icons/fa';
import { FaMountain } from 'react-icons/fa6';
import { KeyboardEvent } from 'react';

interface PerkType {
  perk: string;
  type: 'ghost' | 'outline' | 'default' | 'secondary';
  onClick?: () => void;
  hideText?: boolean;
  isSelected?: boolean;
}

function Perk({ perk, type, onClick, hideText = false, isSelected = false }: PerkType) {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick();
      }
    }
  };

  return (
    <Badge
      variant={type}
      onClick={onClick}
      className={`items-center ${onClick ? 'cursor-pointer' : ''} focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 text-nowrap`}
      tabIndex={0}
      role="checkbox"
      aria-checked={isSelected}
      onKeyDown={handleKeyDown}
    >
      <span className="mr-1">
        {perk === 'Free Wi-Fi' && <FaWifi className="w-5 h-5 text- mr-1" />}
        {perk === 'Pyramids View' && <TbPyramid className="w-4 h-4 mr-1" />}
        {perk === 'Balcony' && <MdBalcony className="w-4 h-4 mr-1" />}
        {perk === 'Garden' && <Flower2 className="w-4 h-4 mr-1" />}
        {perk === 'Sea View' && <Sea className="w-4 h-4 mr-1" />}

        {perk === 'Private Pool' && <TbPool className="w-4 h-4 mr-1" />}
        {perk === 'Air Conditioning' && <TbAirConditioning className="w-4 h-4 mr-1" />}
        {perk === 'Swimming Pool' && <FaSwimmingPool className="w-4 h-4 mr-1" />}
        {perk === 'Private Beach' && <FaUmbrellaBeach className="w-4 h-4 mr-1" />}
        {perk === 'BBQ Area' && <MdOutlineOutdoorGrill className="w-4 h-4 mr-1" />}
        {perk === 'Gym' && <CgGym className="w-4 h-4 mr-1" />}
        {perk === 'Pet-friendly' && <LuDog className="w-4 h-4 mr-1" />}
        {perk === 'Outdoor Seating Area' && <BiChair className="w-4 h-4 mr-1" />}
        {perk === 'Home Theater' && <BiCameraMovie className="w-4 h-4 mr-1" />}
        {perk === 'Jacuzzi' && <MdOutlineBathtub className="w-4 h-4 mr-1" />}
        {perk === 'Washing Machine' && <PiWashingMachine className="w-4 h-4 mr-1" />}
        {perk === 'Parking' && <FaSquareParking className="w-4 h-4 mr-1" />}
        {perk === 'Smoking Allowed' && <FaSmoking className="w-4 h-4 mr-1" />}
        {perk === 'Fridge' && <TbFridge className="w-4 h-4 mr-1" />}
        {perk === 'Kitchen' && <CookingPot className="w-4 h-4 mr-1" />}
        {perk === 'TV' && <FaTv className="w-4 h-4 mr-1" />}
        {perk === 'Mountain View' && <FaMountain className="w-4 h-4 mr-1" />}
        {perk === 'Nile View' && <BiWater className="w-4 h-4 mr-1" />}
      </span>
      {!hideText && (
        <span className={`mr-2 ${type === 'default' ? 'text-white' : 'text-primary'}`}>{perk}</span>
      )}
    </Badge>
  );
}

export default Perk;
